<script>
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';
import { BUSINESS_CUSTOMER } from '@/modules/companies/common/companyTypes';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'BusinessCustomerFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapCacheActions('company', ['retrieveCompaniesByType']),

    getData() {
      return this.retrieveCompaniesByType(BUSINESS_CUSTOMER).then(
        ({ data }) => {
          return data;
        }
      );
    }
  }
};
</script>
